module.exports = __webpack_public_path__ + "static/toro-ac6f5a40f018d48681a22de1be9ca09e.png";